module.exports = __webpack_public_path__ + "media/images/emblems/Bruetten-blazon-108f4871de54f785b13bea09b97fda61.svg";